;(function () {
	const BP = 990

	function closeAllCardsIn(root) {
		root.querySelectorAll('.koku-notalari__card').forEach(function (btn) {
			btn.setAttribute('aria-expanded', 'false')
		})
	}

	function destroySwiper(root) {
		if (root._kokuSwiper) {
			root._kokuSwiper.destroy(true, true)
			root._kokuSwiper = null
		}
	}

	function initSwiper(root) {
		const el = root.querySelector('[data-koku-swiper]')
		if (!el || typeof Swiper === 'undefined') {
			return
		}

		if (window.innerWidth >= BP) {
			destroySwiper(root)
			return
		}

		if (root._kokuSwiper) {
			return
		}

		const gapRaw = getComputedStyle(root).getPropertyValue('--koku-gap').trim()
		const gap = parseFloat(gapRaw) || 4

		root._kokuSwiper = new Swiper(el, {
			slidesPerView: 1,
			spaceBetween: gap,
			watchOverflow: true,
			navigation: {
				nextEl: root.querySelector('[data-koku-next]'),
				prevEl: root.querySelector('[data-koku-prev]'),
			},
		})
	}

	function refreshSwipers() {
		document.querySelectorAll('[data-koku-notalari]').forEach(function (root) {
			if (window.innerWidth >= BP) {
				destroySwiper(root)
			} else {
				destroySwiper(root)
				initSwiper(root)
			}
		})
	}

	let resizeTimer
	function onResizeAll() {
		clearTimeout(resizeTimer)
		resizeTimer = setTimeout(refreshSwipers, 120)
	}

	function initRoot(root) {
		initSwiper(root)
	}

	function initAll() {
		document.querySelectorAll('[data-koku-notalari]').forEach(initRoot)
	}

	if (!window.__kokuNotlariBound) {
		window.__kokuNotlariBound = true

		document.addEventListener(
			'click',
			function (e) {
				const root = e.target.closest('[data-koku-notalari]')
				if (!root) {
					return
				}

				const card = e.target.closest('.koku-notalari__card')
				if (card && root.contains(card)) {
					const isOpen = card.getAttribute('aria-expanded') === 'true'
					closeAllCardsIn(root)
					if (!isOpen) {
						card.setAttribute('aria-expanded', 'true')
					}
					return
				}

				closeAllCardsIn(root)
			},
			true
		)

		document.addEventListener('click', function (e) {
			document.querySelectorAll('[data-koku-notalari]').forEach(function (root) {
				if (!root.contains(e.target)) {
					closeAllCardsIn(root)
				}
			})
		})

		window.addEventListener('resize', onResizeAll)
	}

	document.addEventListener('shopify:section:load', function (e) {
		const root = e.target.matches('[data-koku-notalari]')
			? e.target
			: e.target.querySelector('[data-koku-notalari]')
		if (root) {
			initRoot(root)
		}
	})

	document.addEventListener('shopify:section:unload', function (e) {
		const root = e.target.matches('[data-koku-notalari]')
			? e.target
			: e.target.querySelector('[data-koku-notalari]')
		if (root) {
			destroySwiper(root)
		}
	})

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll)
	} else {
		initAll()
	}
})()
